// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Y40eH","groupContainer":"styles_groupContainer__kpQmR","cardContainer":"styles_cardContainer__ihlCB"};